import { 
    GET_REPORT_MASTER_DETAIL, 
    REPORT_MASTER_DETAIL_REQUEST, 
    REPORT_MASTER_DETAIL_REQUEST_SUCCESS, 
    REPORT_MASTER_DETAIL_REQUEST_FAILURE,
    GET_REPORT_MASTER_WITH_DETAIL, 
    REPORT_MASTER_WITH_DETAIL_REQUEST, 
    REPORT_MASTER_WITH_DETAIL_REQUEST_SUCCESS, 
    REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE,  
} from "../types";

const initialState = { 
    reportMasterDetail: [],
    reportMasterWithDetail: [],
    loading: false,
    error: null,
}

const reportMasterDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORT_MASTER_DETAIL_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case REPORT_MASTER_DETAIL_REQUEST_FAILURE: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case GET_REPORT_MASTER_DETAIL: {
            return {
                ...state,
                reportMasterDetail: [ ...action.payload || []],
                loading: false,
                error: null
            }
        }
        case REPORT_MASTER_DETAIL_REQUEST_SUCCESS: {
            return {
                ...state,
                loading: false,
                error: null
            }
        }
        case REPORT_MASTER_WITH_DETAIL_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case GET_REPORT_MASTER_WITH_DETAIL: {
            return {
                ...state,
                reportMasterWithDetail: action.payload || {},
                loading: false,
                error: null
            }
        }
        case REPORT_MASTER_WITH_DETAIL_REQUEST_SUCCESS: {
            return {
                ...state,
                loading: false,
                error: null
            }
        }
        default:
            return state;
    }
};

export default reportMasterDetailReducer;